export default __webpack_public_path__ + "static/media/2930 spice rack F top.c44a7ee2.png";